module.exports = __webpack_public_path__ + "img/jacques_vabre-bahia.1438b51a.jpg";